import React from 'react';
import { Radio } from 'rsuite';
import { constructMarkup } from '../../common/utils';

export interface AnnotatedRadioProps {
  value: string;
  label: string;
  annotation?: () => React.ReactNode | null;
  disabled?: boolean;
}

const AnnotatedRadio = ({
  value,
  label,
  annotation = () => null,
  disabled = false,
}: AnnotatedRadioProps) => {
  return (
    <>
      <Radio
        value={value}
        disabled={disabled}
      >
        {constructMarkup(label)}
      </Radio>
      {annotation()}
    </>
  );
};

export default AnnotatedRadio;
